var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2609 7H7.73909C6.22633 7 5 8.23166 5 9.751V25.249C5 26.7683 6.22633 28 7.73909 28H25.2609C26.7737 28 28 26.7683 28 25.249V9.751C28 8.23166 26.7737 7 25.2609 7Z",
    stroke: "#03061F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 16C10.3284 16 11 15.3284 11 14.5C11 13.6716 10.3284 13 9.5 13C8.67157 13 8 13.6716 8 14.5C8 15.3284 8.67157 16 9.5 16Z",
    fill: "#0B0321"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6331 23.1333C17.4983 23.1333 18.1997 22.4319 18.1997 21.5667C18.1997 20.7014 17.4983 20 16.6331 20C15.7678 20 15.0664 20.7014 15.0664 21.5667C15.0664 22.4319 15.7678 23.1333 16.6331 23.1333Z",
    fill: "#0B0321"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6331 16.1333C17.4983 16.1333 18.1997 15.4319 18.1997 14.5667C18.1997 13.7014 17.4983 13 16.6331 13C15.7678 13 15.0664 13.7014 15.0664 14.5667C15.0664 15.4319 15.7678 16.1333 16.6331 16.1333Z",
    fill: "#0B0321"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.834 15.8667C23.6624 15.8667 24.334 15.1951 24.334 14.3667C24.334 13.5383 23.6624 12.8667 22.834 12.8667C22.0056 12.8667 21.334 13.5383 21.334 14.3667C21.334 15.1951 22.0056 15.8667 22.834 15.8667Z",
    fill: "#0B0321"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0999 23.1333C10.9651 23.1333 11.6665 22.4319 11.6665 21.5667C11.6665 20.7014 10.9651 20 10.0999 20C9.23462 20 8.5332 20.7014 8.5332 21.5667C8.5332 22.4319 9.23462 23.1333 10.0999 23.1333Z",
    fill: "#0B0321"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11 5V8.33333M21.6667 5V8.33333",
    stroke: "#03061F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.2fba59b7a1d284816cfb84d36855da1b.svg";
export { ForwardRef as ReactComponent };